module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad1/img_achievement02-87807dae9f4c781ae6428e05647185ab.jpg";